"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBSCRIPTION_INTERVAL = void 0;
// THIS IS AUTHORIZE CONSTANT, don't change the values to UPPERCASE
exports.SUBSCRIPTION_INTERVAL = {
    DAY: 'day',
    MONTH: 'month'
};
//# sourceMappingURL=subscriptionInterval.js.map